<div class="footer">
  <div class="footer-icon-list" *ngIf="!userIsLoggedIn() && activeRoute('login')">
    <div>
      <a href="https://occon.de" target="_blank">
        <img class="img-responsive center-block footer_icon" src="assets/img/login/OCCON.png" alt="occon_logo">
      </a>
    </div>
    <div>
      <div class="footer-ring">
        <a href="https://www.xing.com/companies/occongmbh" target="_blank">
          <fa-icon [icon]="fabXing"></fa-icon>
        </a>
      </div>
    </div>
    <div>
      <div class="footer-ring">
        <a href="https://twitter.com/OCCON" target="_blank">
          <fa-icon [icon]="fabTwitter"></fa-icon>
        </a>
      </div>
    </div>
    <div>
      <div class="footer-ring">
        <a href="https://www.linkedin.com/company/occon-gmbh" target="_blank">
          <fa-icon [icon]="fabLinked"></fa-icon>
        </a>
      </div>
    </div>
  </div>

  <div class="footer-data">
    <div>
      {{ "GENERAL.APP_VERSION" | translate:locale.language }} {{ version }}
    </div>
    <div>
      © OCCON GmbH {{ year }}
    </div>
    <div>
      <strong><a (click)="showImprint = true">{{ 'GENERAL.IMPRINT' | translate:locale.language }}</a> | <a
        (click)="showDisclaimer = true">{{ 'GENERAL.DISCLAIMER' | translate:locale.language }}</a></strong>
    </div>
  </div>
</div>

<p-dialog [(visible)]="showImprint" styleClass="occon-modal occon-modal-lg portrait new-tender-modal"
          [resizable]="false" [modal]="true" [dismissableMask]="true" appendTo="body">
  <p-header>
    <span>{{'GENERAL.IMPRINT' | translate:locale.language }}</span>
  </p-header>
  <imprint></imprint>
  <p-footer>
    <button class="btn btn-success"
            (click)="showImprint = false">{{'DATA.SHEETDESIGNER.LABELS.OK' | translate:locale.language }}</button>
  </p-footer>
</p-dialog>

<p-dialog [(visible)]="showDisclaimer" styleClass="occon-modal occon-modal-lg portrait new-tender-modal"
          [resizable]="false" [modal]="true" [dismissableMask]="true" appendTo="body">
  <p-header>
    <span>{{'GENERAL.DISCLAIMER' | translate:locale.language }}</span>
  </p-header>
  <disclaimer></disclaimer>
  <p-footer>
    <button class="btn btn-success"
            (click)="showDisclaimer = false">{{'DATA.SHEETDESIGNER.LABELS.OK' | translate:locale.language }}</button>
  </p-footer>
</p-dialog>
